import axios from 'axios';

export const DEFAULT_LANGUAGE = 'pt';

export const SUPPORTED_LANGUAGES = [
  { code: 'pt', labelKey: 'components.LanguageArea.portuguese', fallbackLabel: 'Português' },
  { code: 'en', labelKey: 'components.LanguageArea.english', fallbackLabel: 'Inglês' },
];

export const normalizeLanguageCode = (language) => {
  const code = String(language || DEFAULT_LANGUAGE).split('-')[0].toLowerCase();
  return SUPPORTED_LANGUAGES.some(item => item.code === code) ? code : DEFAULT_LANGUAGE;
};

export const getPreferredLanguage = (user) => {
  const storedLanguage = localStorage.getItem('i18nextLng');
  return normalizeLanguageCode(user?.language || storedLanguage || DEFAULT_LANGUAGE);
};

export const setApiLanguageHeader = (language) => {
  const normalizedLanguage = normalizeLanguageCode(language);
  axios.defaults.headers.common['Accept-Language'] = normalizedLanguage;
  return normalizedLanguage;
};
